import { render, staticRenderFns } from "./StockcounttabletPage.vue?vue&type=template&id=66d70edb"
import script from "./StockcounttabletPage.vue?vue&type=script&lang=js"
export * from "./StockcounttabletPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports